import { Upload } from "antd";
import styled, { css, keyframes } from "styled-components";
import { appearFromLeft } from "../1-Layout/styles";
import TextArea from "antd/lib/input/TextArea";

export const ImagesContainer = styled.div`
  max-width: 1084px;
  margin: 0 auto;

  ${({ animated }) =>
    animated &&
    css`
      animation: ${appearFromLeft} 1s;
    `}
`;

export const OptionWrapper = styled.div`
  animation: ${appearFromLeft} 1s;
`;

export const NoFile = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: -0.3px;
  color: #334155;
`;

export const ImagesOptions = styled.div`
  --gray: #6c6c6c;
  display: flex;
  align-items: center;
  gap: 16px;

  & > span {
    color: var(--gray);
    font-weight: 400;
    font-family: var(--OpenSans);
    font-size: 18px;
    line-height: 100%;
    text-transform: lowercase;
  }
`;

export const OptionContainer = styled.div`
  --blue: #11a7d9;
  --background: #fafafc;
  --shadow: #1018280d;
  cursor: pointer;

  flex: 1;
  border-radius: 10px;
  width: 515px;
  border: 4px solid;
  padding: 39px 16px;
  border-color: ${({ selected }) =>
    selected ? `var(--blue)` : `var(--background)`};

  background-color: var(--background);

  transition: all 300ms;

  box-shadow: ${({ selected }) =>
    selected
      ? `0px 5px 15px 0px rgba(0,0,0,0.3)`
      : `0px 5px 15px 0px transparent;`};
`;

export const OptionIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background-color: #f2f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OptionContent = styled.div`
  --Inter: "Inter", sans-serif;
  --gray: #6c6c6c;
  --darkGray: #3a3a3c;

  max-width: 330px;

  p {
    margin-top: 8px;
    margin-bottom: 4px;

    color: var(--darkGray);
    font-weight: 600;
    font-family: var(--Inter);
    font-size: 18px;
    line-height: 20px;
  }

  span {
    color: var(--gray);
    font-weight: 400;
    font-family: var(--Inter);
    font-size: 16px;
    line-height: 20px;
  }
`;

export const UploadComponent = styled(Upload)`
  margin-top: 8px;

  .ant-upload-list-picture-card-container {
    display: inline-block;
    width: 250px;
    height: 250px;
    margin: 0 8px 8px 0;
    vertical-align: top;
  }

  .ant-upload.ant-upload-select-picture-card {
    width: auto;
    height: auto;
    margin: 0;
    border: none;
    background-color: unset;
    padding: 0;
    border-radius: unset;
    cursor: pointer;
  }

  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 250px;
    height: 250px;
  }

  .anticon-delete,
  .anticon-eye {
    width: 20px !important;
    height: 20px !important;
    & > svg {
      transition: all 100ms;
      width: 100%;
      height: 100%;
    }
  }

  .anticon-delete {
    & > svg:hover {
      color: #ff4747;
    }
  }
`;

export const Textarea = styled(TextArea)`
  border-radius: 16px;
  padding: 16px;

  ${({ error }) =>
    error &&
    css`
      &.ant-input:focus,
      &.ant-input-focused {
        border-color: #c53030 !important;
        box-shadow: 0 0 0 2px transparent;
      }

      &.ant-input:hover {
        border-color: #c53030 !important;
      }
    `}
`;

export const SelectGeneratedHeader = styled.header`
  margin-bottom: 16px;
`;
export const SelectGeneratedTitle = styled.p`
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #3a3a3c;

  & > span {
    font-weight: 400;
  }

  & > span.warningToken {
    color: #6c6c6c;
    font-weight: 300;
    font-size: 14px;
    margin-left: 8px;
  }

  margin-bottom: 0;
`;

export const SelectGeneratedSubtitle = styled.p`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  margin-bottom: 0;
  color: #444444;
`;

export const SelectGeneratedImageContainer = styled.div`
  min-height: 465px;
  border-radius: 8px;
  gap: 10px;
  border-width: 1px;
  padding: 24px;

  border: 1px solid #dde5e9;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const SelectGeneratedImageEmpty = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  p {
    font-family: "Open Sans";
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    margin-bottom: 0;
    margin-top: 8px;
    color: #3a3a3c;
  }

  span {
    font-family: "Open Sans";
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #444444;
  }
`;

const appear = keyframes`
   from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const GeneratedImage = styled.img`
  aspect-ratio: 1080 / 1350;
  width: 380px;
  object-fit: cover;
  border: 4.5px solid transparent;
  box-shadow: 0px 0px 10px transparent;
  transition: all 300ms;
  cursor: pointer;

  &:hover {
    border-color: rgba(17, 167, 217, 0.55);
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: #11a7d9;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5) !important;
    `};

  ${({ isLoading, error }) =>
    !isLoading &&
    !error &&
    css`
      animation: ${appear} 500ms forwards;
    `};
  }
`;

const scaleUp = keyframes`
  0% {
    transform: scale(0);
  }
  80% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

export const ImageContainer = styled.div`
  aspect-ratio: 1080 / 1350;
  width: 380px;
  position: relative;
  overflow: hidden;
  transform: scale(0);
  animation: ${scaleUp} 700ms ease-out forwards;
`;

export const SkeletonWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  aspect-ratio: 1080 / 1350;
  width: 380px;
`;

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(360deg); /* Stay at 360deg */
  }
`;

const spin_4991 = keyframes`
  10% {
    -webkit-transform: translateY(-102%);
    transform: translateY(-102%);
  }

  25% {
    -webkit-transform: translateY(-100%);
    transform: translateY(-100%);
  }

  35% {
    -webkit-transform: translateY(-202%);
    transform: translateY(-202%);
  }

  50% {
    -webkit-transform: translateY(-200%);
    transform: translateY(-200%);
  }

  60% {
    -webkit-transform: translateY(-302%);
    transform: translateY(-302%);
  }

  75% {
    -webkit-transform: translateY(-300%);
    transform: translateY(-300%);
  }

  85% {
    -webkit-transform: translateY(-402%);
    transform: translateY(-402%);
  }

  100% {
    -webkit-transform: translateY(-400%);
    transform: translateY(-400%);
  }
`;

export const GeneratingImage = styled.div`
  width: 100%;
  height: 100%;

  border-radius: 4px;
  /* background-color: #f5f5f5; */
  border: 1px solid #dadada;
  position: relative;

  & > div:first-child {
    position: absolute;
    inset: 0;
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
    align-items: center;
    height: 100%;
  }

  img {
    width: 80px;
    object-fit: cover;
    height: 80px;
    animation: ${rotate} 3.5s ease-in-out infinite;
    transform-origin: center;
    will-change: transform;
  }

  .words {
    overflow: hidden;
    position: relative;
    height: 33px;
  }
  .words::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      var(--bg-color) 10%,
      transparent 30%,
      transparent 70%,
      var(--bg-color) 90%
    );
    z-index: 20;
  }

  .word {
    text-align: center;
    font-family: "Open sans";
    font-weight: 700;
    font-size: 22px;
    text-transform: capitalize;
    line-height: 100%;
    display: block;
    height: 200%;
    padding-left: 6px;
    color: #002244;
    animation: ${spin_4991} 10s infinite;
  }
`;

export const SelectedImageTag = styled.div`
  padding: 2px 10px;
  border-radius: 20px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -10px;
  opacity: 0;
  background-color: #fff;
  color: #11a7d9;
  z-index: 5;
  border: 3px solid #11a7d9;
  font-family: "Open sans";
  font-weight: 700;

  transition: all 300ms;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  ${({ selected }) =>
    selected &&
    css`
      opacity: 1;
      top: 10px;
    `};
`;

export const FailedToLoad = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  aspect-ratio: 1080 / 1350;
  width: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #dadada;
  flex-direction: column;
  gap: 4px;
  color: #002244 !important;
  z-index: 2;

  opacity: 0;
  transition: all 300ms;

  & > p {
    font-weight: 600;
    font-family: "Open sans";
    font-size: 20px;
    line-height: 100%;
    width: 60% !important;
    text-align: center;
    margin-bottom: 0;
    color: #002244 !important;
  }

  ${({ isLoading }) =>
    !isLoading &&
    css`
      animation: ${appear} 500ms forwards;
    `}
`;
